import React from 'react';

function TableCell({
  children,
  spinInfo,
  rowInfo,
  dataKey,
  additionalInfo,
  additionalStyle,
  clickHandler = null,
}) {
  return (
    <div className='cpt-table-column' onClick={clickHandler}>
      {children}
      {dataKey === 'amount' && (spinInfo.freebetId || spinInfo.freeBetId) && (
        <p className='game-favicon FreeBet' />
      )}
      <span className='cpt-table-text' style={{ cursor: additionalStyle || null }}>
        <p>{rowInfo}</p>
        {additionalInfo}
      </span>
    </div>
  );
}

export default TableCell;
